import React, { Component } from 'react';

import { chainesLocales } from './../include/chainesLocales';
import { getJson, getErrMsg } from '../service/serviceUtil';

import ContextualMessage from '../components/contextualMessage';
import InputPassword from '../components/inputPassword';
import UserDisplay from '../components/userDisplay';

class CreerMotPasse extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            token: this.props.token,
            password: "",
            passwordConfirm: "",
            validations: {
                isMinLength: false,
                hasUpperChar: false,
                hasLowerChar: false,
                hasNumber: false
            },
            error: null,
            txtMsg: null,
            typeMsg: null,
            errorApi: false
        };
    }

    get labels() {
        return chainesLocales['CreerMotPasse'][this.props.lang];
    }

    render() {
        let submitDisabled = (!this.isPasswordConfirmed() || !this.isPasswordValid());

        return (
            <form className="text-left" onSubmit={this.onSubmit.bind(this)}>
                <h1>{this.labels.title}</h1>
                <UserDisplay user={this.props.user.username} lang={this.props.lang} />
                {
                    this.state.error ? <ContextualMessage type="error" content={getErrMsg(this.state.error, this.props.lang)} /> : null
                }
                {
                    this.state.txtMsg ? <ContextualMessage type={this.state.typeMsg} showIcon={false} content={this.state.txtMsg} /> : null
                }
                {
                    this.state.errorApi ? <ContextualMessage type="error" showIcon={false} content={chainesLocales['ErrApi'][this.props.lang].msg} /> : null
                }
                <div className="row">
                    <div className="col-6">
                        <div className="form-group">
                            <label htmlFor="password" className="font-weight-bold" style={{ fontSize: "1.1rem" }}>{this.labels.labelPwd}</label>
                            <InputPassword id="password" showHelp={(this.isPasswordValid() === false)} helpMessage={this.labels.invalidMsgPwd} lang={this.props.lang} focus={true} value={this.state.password} onChange={this.onChangeWithValidations.bind(this)} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="passwordConfirm" className="font-weight-bold" style={{ fontSize: "1.1rem" }}>{this.labels.labelConfirm}</label>
                            <InputPassword id="passwordConfirm" isInvalid={(this.state.passwordConfirm.length > 0 && this.isPasswordConfirmed() === false)} invalidMessage={this.labels.invalidMsgConfirm} lang={this.props.lang} value={this.state.passwordConfirm} onChange={this.onChange.bind(this)} />
                        </div>
                        <div>
                            <button className="btn btn-primary" type="submit" disabled={submitDisabled}><span className="label">{this.labels.button}</span><span className="spinner"></span></button>
                        </div>
                    </div>
                    <div className="col-6">
                        <ContextualMessage type="info" showIcon={false}>
                            <p>{this.labels.critTitle}</p>
                            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                                <li className="d-flex"><div className={`validationIndicator ${this.state.validations.isMinLength ? 'valid' : 'invalid'}`} /><div className="w-100">{this.labels.crit1}</div></li>
                                <li className="d-flex"><div className={`validationIndicator ${this.state.validations.hasUpperChar ? 'valid' : 'invalid'}`} /><div className="w-100">{this.labels.crit2}</div></li>
                                <li className="d-flex"><div className={`validationIndicator ${this.state.validations.hasLowerChar ? 'valid' : 'invalid'}`} /><div className="w-100">{this.labels.crit3}</div></li>
                                <li className="d-flex"><div className={`validationIndicator ${this.state.validations.hasNumber ? 'valid' : 'invalid'}`} /><div className="w-100">{this.labels.crit4}</div></li>
                            </ul>
                        </ContextualMessage>
                    </div>
                </div>
            </form>
        )
    }

    onSubmit(e) {
        e.preventDefault();
        
        if (this.isPasswordValid() && this.isPasswordConfirmed()) {
            if (document.querySelector) {
                document.querySelector('button[type="submit"]').disabled = true;
                if (document.body.classList) document.querySelector('button[type="submit"]').classList.add('loading');
            }

            let formData = new FormData();
            
            formData.append("password", this.state.password.trim());
            formData.append("token", this.state.token);

            let defaultParams = {
                lang: this.props.lang,
                suffixe: this.props.suffixe
            };

            let fetchOptions = {
                method: "POST",
                credentials: "same-origin",
                body: formData
            };

            getJson('createPassword', defaultParams, fetchOptions).then(data => {
                if (data.mdpCree === true) {
                    this.props.onPageSuccess({ cmp: data });
                } else {
                    this.setState({ error: data.error, typeMsg: data.type, txtMsg: data.message, errorApi: ((!data.error && !data.message) ? true : false) }, () => {
                        if (document.querySelector) {
                            document.querySelector('button[type="submit"]').disabled = false;
                            if (document.body.classList) document.querySelector('button[type="submit"]').classList.remove('loading');
                        }
                    });
                }
            }).catch(err => {
                console.error("Erreur API creer mot de passe: " + err);
    
                this.setState({ errorApi: true, error: null, typeMsg: null, txtMsg: null }, () => {
                    if (document.querySelector) {
                        document.querySelector('button[type="submit"]').disabled = false;
                        if (document.body.classList) document.querySelector('button[type="submit"]').classList.remove('loading');
                    }
                });
            });
        } else {
            this.setState({ error: { message: this.labels.invalidMsgCrit }, errorApi: false, typeMsg: null, txtMsg: null }, () => {
                if (document.querySelector) {
                    document.querySelector('button[type="submit"]').disabled = true;
                    if (document.body.classList) document.querySelector('button[type="submit"]').classList.remove('loading');
                }
            });
        }
    }

    onChange(e) {
        this.setState({ [e.target.id]: e.target.value.trim() });
    }

    onChangeWithValidations(e) {
        let value = e.target.value.trim();

        let validationState = {
            isMinLength: this.isMinLength(value),
            hasUpperChar: this.hasUpperChar(value),
            hasLowerChar: this.hasLowerChar(value),
            hasNumber: this.hasNumber(value)
        };

        this.setState({ [e.target.id]: value, validations: validationState });
    }

    //Valider si le champ password est identique au champ de controle passwordConfirm
    isPasswordConfirmed() {
        let valid = true;

        if (this.state.password.length === 0 || this.state.passwordConfirm.length === 0 || this.state.password !== this.state.passwordConfirm) {
            valid = false;
        }

        return valid;
    }

    //Valider les critères d'acceptabilités
    isPasswordValid() {
        let valid = true;

        for (let criterion in this.state.validations) {
            if (this.state.validations[criterion] === false) {
                valid = false;
                break;
            }
        }

        return valid;
    }

    isMinLength(val) {
        return (val.length >= 8 ? true : false);
    }

    hasLowerChar(val) {
        return (val.toUpperCase() !== val);
    }

    hasUpperChar(val) {
        return (val.toLowerCase() !== val);
    }

    hasNumber(val) {
        return /\d/g.test(val);
    }
}

export default CreerMotPasse;